import React, { useState, useEffect } from "react";
import "../../styles/Home.css";
import { useDispatch, useSelector } from "react-redux";
import NocChart from "./NocChart.tsx";
import NocMap from "./NocMap.tsx";
import NocHeader from "../../components/Layout/NocHeader.tsx";
import {
  CHART_TYPE,
  DATE_FORMAT,
  NEW_CROP_API_LEVEL,
} from "../../utils/Constants.tsx";
import {
  getProductData,
  getGridWiseData,
  getStateWiseData,
  getCropData,
  getPerilData,
  getPOSPTargetAndAchieved,
} from "./NocChartHelper.ts";
import moment from "moment";
import { fetchCountryStateWiseDetails } from "../../services/CountryAPI.tsx";

const NocHome = () => {
  const [gridId, setGridId] = useState<string>("");
  const [isLoading, setIsLoading] = useState(true);
  const [levelOne, setLevelOne] = useState("");
  const [levelTwo, setLevelTwo] = useState("");

  const [pospmCountData, setPOSPMCountData] = useState(null);
  const [POSPTarget, setPOSPTarget] = useState(null);
  const [productData, setProductData] = useState(null);
  const [stateData, setStateData] = useState(null);
  const [perilData, setPerilData] = useState(null);
  const [gridData, setGridData] = useState(null);
  const [cropData, setCropData] = useState(null);
  const [pospCountData, setPospCountData] = useState(null);

  const activeView = useSelector((state: any) => state?.filter?.activeView);
  const dispatch: any = useDispatch();
  const cropViewData = useSelector((state: any) => state?.map?.cropData);
  const viewData = useSelector((state: any) => state?.map?.stateViewData?.data);
  const pospData = useSelector((state: any) => state?.map?.pospData);
  const pospTargetData = useSelector(
    (state: any) => state?.map?.pospTargetData
  );

  useEffect(() => {
    const params = {
      startdate: moment().subtract(1, "days").format(DATE_FORMAT.YYYY_MM_DD),
      enddate: moment().format(DATE_FORMAT.YYYY_MM_DD),
    };
    dispatch(fetchCountryStateWiseDetails(params));
  }, []);

  useEffect(() => {
    if (pospData?.length) {
      setPospCountData(getGridWiseData(pospData, levelOne, "POSP Count"));
    }
  }, [pospData]);
  useEffect(() => {
    if (pospTargetData?.length) {
      setPOSPTarget(
        getPOSPTargetAndAchieved(pospTargetData, levelOne, "Target")
      );
    }
  }, [pospTargetData]);

  useEffect(() => {
    if (levelOne === "POSPm" && levelTwo && cropViewData) {
      setPOSPMCountData(getGridWiseData(cropViewData, levelOne, "POSPm Count"));
      setIsLoading(false);
    }

    if (NEW_CROP_API_LEVEL.includes(levelTwo) && cropViewData) {
      setCropData(getCropData(cropViewData, levelOne, levelTwo));
      setIsLoading(false);
    }
  }, [cropViewData]);

  useEffect(() => {
    if (viewData?.length) {
      if(levelTwo === "Customer Count"){
        setIsLoading(false);
      }
      setProductData(getProductData(viewData, levelOne, levelTwo));
      if (levelTwo === "Total Claim Count") {
        setPerilData(getPerilData(viewData, levelOne, levelTwo));
      } else {
        setGridData(getGridWiseData(viewData, levelOne, levelTwo));
      }
      setStateData(getStateWiseData(viewData, levelOne, levelTwo));
      if (!NEW_CROP_API_LEVEL.includes(levelTwo)) {
        setCropData(getCropData(viewData, levelOne, levelTwo));
      }
    }
  }, [viewData]);
  useEffect(() => {
    setPospCountData(null);
    setPOSPTarget(null);
    setPOSPMCountData(null);
    setCropData(null);
    setPerilData(null);
    setGridData(null);
    setStateData(null);
    setProductData(null);
  }, [levelTwo]);

  const getCharts = () => {
    return (
      <>
        <div className="col-8">
          {levelOne === "POSPm" && levelTwo && (
            <>
              <div className="row">
                <div className="col card-style card align-middle">
                  <NocChart
                    data={pospCountData}
                    chartType={CHART_TYPE.BAR}
                    isLoading={isLoading}
                  />
                </div>
                <div className="col card-style card align-middle">
                  <NocChart
                    data={pospmCountData}
                    chartType={CHART_TYPE.BAR}
                    isLoading={isLoading}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col card-style card align-middle">
                  <NocChart
                    data={POSPTarget}
                    chartType={CHART_TYPE.BAR}
                    isLoading={isLoading}
                  />
                </div>
              </div>
            </>
          )}
          {levelOne && levelTwo && levelTwo !== "Target" && (
            <>
              <div className="row">
                <div className="col card-style card align-middle">
                  {levelTwo === "Amount Disbursed" ? 
                  <NocChart
                    chartType={CHART_TYPE.BAR}
                    data={productData}
                    isLoading={isLoading}
                  />:
                  <>
                   <NocChart
                    chartType={CHART_TYPE.DOUGHNUT}
                    data={productData}
                    isLoading={isLoading}
                  /></>}
                </div>
                <div className="col card-style card align-middle">
                  {levelTwo === "Total Claim Count" && (
                    <NocChart
                      data={perilData}
                      chartType={CHART_TYPE.PIE}
                      isLoading={isLoading}
                    />
                  )}
                  {levelTwo !== "Total Claim Count" && (
                    <NocChart
                      data={gridData}
                      chartType={CHART_TYPE.BAR}
                      isLoading={isLoading}
                    />
                  )}
                </div>
              </div>
              <div className="row">
                <div className="col card-style card align-middle">
                  <NocChart
                    data={stateData}
                    chartType={CHART_TYPE.BAR}
                    isLoading={isLoading}
                  />
                </div>
                <div className="col card-style card align-middle">
                  {NEW_CROP_API_LEVEL.includes(levelTwo) && cropViewData && (
                    <>
                      <NocChart
                        data={cropData}
                        chartType={CHART_TYPE.BUBBLE}
                        isLoading={isLoading}
                      />
                    </>
                  )}
                  {!NEW_CROP_API_LEVEL.includes(levelTwo) && (
                    <NocChart
                      data={cropData}
                      chartType={CHART_TYPE.BUBBLE}
                      isLoading={isLoading}
                    />
                  )}
                </div>
              </div>
            </>
          )}
        </div>
      </>
    );
  };
  return (
    <>
      <NocHeader levelOne={levelOne} levelTwo={levelTwo} />
      <div className="noc-main-container">
        <div className="row">
          {getCharts()}
          <div className="col-4">
            <NocMap
              setGridId={setGridId}
              gridId={gridId}
              isLoading={isLoading}
              setIsLoading={setIsLoading}
              levelOne={levelOne}
              levelTwo={levelTwo}
              setLevelOne={setLevelOne}
              setLevelTwo={setLevelTwo}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default NocHome;
